export const DEVELOPERS_SETTINGS_PATHS = {
  apiKeys: '/account/developers/api-keys',
  llms: '/account/developers/llms',
  speechModels: '/account/developers/speech-models',
  eventNotifications: '/account/developers/event-notifications',
} as const;

export const DEVELOPER_MODULES = [
  'credentials',
  'language_models',
  'speech_models',
  'plugins',
] as const;
